import { useAuth0 } from '@auth0/auth0-react'
import React, { useCallback, useEffect, useMemo, useRef, VFC } from 'react'
import iconErrorClose from '../../../images/icons/close-error.svg'
import iconSuccessClose from '../../../images/icons/close-success.svg'
import iconError from '../../../images/icons/icon-error.svg'
import { RegistrationMessageData } from '../../../lib/registration'
import * as Styled from './styled'

export interface RegistrationMessageProps {
  message: RegistrationMessageData
  onDismiss?: () => void
}

export const RegistrationMessage: VFC<RegistrationMessageProps> = ({ message, onDismiss }) => {
  const { loginWithRedirect } = useAuth0()
  const login = useCallback(() => loginWithRedirect(), [loginWithRedirect])

  const { showResetPassword } = useMemo(() => {
    return {
      showResetPassword: message.actions?.includes('reset_password'),
    }
  }, [message.actions])

  const Message = useMemo(() => {
    switch (message.type) {
      case 'success':
        return Styled.SuccessMessage
      case 'error':
        return Styled.ErrorMessage
      default:
        return Styled.Message
    }
  }, [message.type])

  const errorBoxRef = useRef<HTMLDivElement>(null)
  useEffect(() => {
    errorBoxRef.current?.scrollIntoView()
  }, [message])

  return (
    <Message ref={errorBoxRef}>
      {message.type === 'error' && (
        <Styled.ErrorIcon>
          <img src={iconError} alt="Error" />
        </Styled.ErrorIcon>
      )}
      <Styled.Content>
        <p>{message.details}</p>
        {showResetPassword && (
          <p>
            <Styled.LoginButton onClick={login}>Login or reset your password.</Styled.LoginButton>
          </p>
        )}
      </Styled.Content>
      {onDismiss && (
        <Styled.CloseButton type="button" onClick={onDismiss}>
          <img src={message.type === 'error' ? iconErrorClose : iconSuccessClose} alt="Close" />
        </Styled.CloseButton>
      )}
    </Message>
  )
}
